<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <div class="hospital-logo" style="text-align: center">
      <img src="https://juseimg.oss-cn-hangzhou.aliyuncs.com/images/logo.png" alt="" style="height:50px;margin-top: 5px">
    </div>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item
        v-for="route in data"
        :key="route.path"
        :item="route"
        :base-path="route.path"
        :class="{'is-active': (activeRoute.includes(route.path) && route.path !== '/') }"
      />
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SidebarItem from './SidebarItem'
import { asyncRouterMap } from '@/router'
import { filterAsyncRoutes, filterAsyncRoutesRecursion } from '@/utils'

export default {
  components: { SidebarItem },
  data() {
    return {
      data: [],
      activeRoute: ''
    }
  },
  created() {
    this.getRouter()
  },
  computed: {
    ...mapGetters(['permission_routers', 'sidebar']),
    isCollapse() {
      return !this.sidebar.opened
    },
    ...mapState('userinfo', ['userInfo', 'currentPage', 'auth']),
    getCurrentMenus() {
      return (menus, str) => {
        return menus.filter(item => item.path.split('/')[1] === str).map(item => {
          return {
            path: '/' + (item.path.split('/')[2] || '')
          }
        })
      }
    }
  },
  watch: {
    currentPage() {
      this.getRouter()
    },
    $route(to, form) {
      this.activeRoute = to.path
    }
  },
  methods: {
    getRouter() {
      let menuList = asyncRouterMap.indexRoute
      if(this.auth.length > 0) {
        if (this.currentPage === '1') {
          const menus = this.getCurrentMenus(this.auth, 'nurseManage')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.nurserRoute, menus))
        } else if (this.currentPage === '2') {
          const menus = this.getCurrentMenus(this.auth, 'userManage')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.userRoute, menus))
        } else if (this.currentPage === '3') {
          const menus = this.getCurrentMenus(this.auth, 'systemManage')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.systemRoute, menus))
        } else if (this.currentPage === '4') {
          const menus = this.getCurrentMenus(this.auth, 'diabetesManage')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.diabetesRoute, menus))
        } else if (this.currentPage === '5') {
          const menus = this.getCurrentMenus(this.auth, 'pointsManage')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.pointsRoute, menus))
        } else if (this.currentPage === '6') {
          const menus = this.getCurrentMenus(this.auth, 'shoppMall')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.shopMallRoute, menus))
        } else if (this.currentPage === '7') {
          const menus = this.getCurrentMenus(this.auth, 'reportForm')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.dataReportForm, menus))
        } else if (this.currentPage === '8') {
          const menus = this.getCurrentMenus(this.auth, 'questionnaireActivity')
          menuList = menuList.concat(filterAsyncRoutes(asyncRouterMap.questionnaireActivityRoute, menus))
        }
        this.data = menuList.filter(menu => !menu.notShow)
      }
    }
  } 
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .hospital-logo{
    height: 60px;
  }
</style>
<style rel="stylesheet/scss" lang="scss" >
  .is-active li{
    /*padding-left: 20px !important;*/
    /*color: rgb(64, 158, 255) !important;*/
    background-color: rgb(48, 65, 86) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue